/* eslint-disable react/jsx-filename-extension */
import { keygen } from '@utils/misc'
import { h, JSX } from 'preact'

export default function Motivators({
    motivators = [],
}) {
    if (!motivators?.length) return null

    return (
        <div className="motivators">
            {motivators.map((motivator, i) => (
                <div
                    className="motivator"
                    key={`motivator-${keygen(i)}`}
                    dangerouslySetInnerHTML={{ __html: motivator }}
                />
            ))}
        </div>
    )
}
